module.exports = __webpack_public_path__ + "img/Garden refuse.fc52f9d7.svg";